import { NEXT_AUTH_METHOD } from '@app/constants/auth';
import { ServiceMethod } from '@app/libs/services';
import { UserInfoModel } from '@app/repositories/me.repository';

import { BaseClientService } from './baseClient.service';

export class MeService extends BaseClientService {
  protected services = {
    update: {
      uri: 'me',
      method: 'PUT' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      contentType: 'application/json',
      params: {
        email: { required: NEXT_AUTH_METHOD === 'email' },
        phone: { required: NEXT_AUTH_METHOD === 'phone' },
        fullname: { required: false },
        address: { required: false },
        alias: { required: false },
        avatar: { required: false },
      },
    },

    info: {
      uri: 'me/info',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },

    uploadAvatar: {
      uri: 'me/avatar',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      contentType: 'multipart/form-data',
      flatParams: true,
      params: {
        file: { required: true },
      },
    },
    uploadSignature: {
      uri: 'me/signature',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      contentType: 'multipart/form-data',
      flatParams: true,
      params: {
        file: { required: true },
      },
    },
    signature: {
      uri: 'me/signature',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
    registerCertificate: {
      uri: 'me/certificates',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
    certificates: {
      uri: 'me/certificates',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        fromDate: { required: false },
        toDate: { required: false },
        orderBy: { required: false },
        pageIndex: { required: false },
        pageSize: { required: false },
        status: { required: false },
      },
    },
    activeCertificate: {
      uri: 'me/certificates/{id}/confirm',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        id: { required: true },
      },
    },
    lock: {
      uri: 'me',
      method: 'DELETE' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
    deleteSignature: {
      uri: 'me/signature',
      method: 'DELETE' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
  };

  update(info: UserInfoModel) {
    return this.send('update', { params: info });
  }

  info() {
    return this.send('info', {});
  }

  uploadAvatar(file: File) {
    return this.send('uploadAvatar', { params: { file } });
  }

  lock() {
    return this.send('lock', {});
  }

  deleteSignature() {
    return this.send('deleteSignature', {});
  }

  signature(path: string) {
    return this.send('signature', { params: { path } });
  }

  registerCertificate() {
    return this.send('registerCertificate', {});
  }

  certificates(params: {
    fromDate?: string;
    toDate?: string;
    orderBy?: string;
    pageIndex?: number;
    pageSize?: number;
    status: ('ACTIVE' | 'INACTIVE' | 'DEACTIVATE')[];
  }) {
    return this.send('certificates', {
      params: {
        ...params,
        status: params.status.join(','),
      },
    });
  }

  activeCertificate(id: string) {
    return this.send('activeCertificate', { params: { id } });
  }

  uploadSignature(file: File) {
    return this.send('uploadSignature', { params: { file } });
  }
}

export const meService = new MeService();
